<div class="billing-documents-modal" #billingDocModal>

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="closeModal()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          {{action}} {{billingDocumentTypeNames[document.type ?? '']}}{{document._id ? ':' : ''}}
          {{ document.serie != invoiceStatuses.DRAFT ? document.serieAndNumber || document.docNumber :
          invoiceStatusesLabels.DRAFT }}
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <form *ngIf="form" class="m-0" [formGroup]="form">
    <div class="row d-flex justify-content-end" *ngIf="!allDataToBilling">
      <button class="btn btn-600 text-danger" style="font-size: .8rem;"
        [ngClass]="{'btn-danger': cancelBtnHover, 'btn-outline-danger': !cancelBtnHover}"
        (click)="openCompanyModal(currentCompany)">Los datos fiscales de tu empresa están incompletos. Haz click aquí
        para completarlos.</button>
    </div>
    <div class="row" *ngIf="!loading">
      <div class="col-md-12 mt-4 document-content" [ngClass]="{darken: readOnly}" (click)="setEditable()">
        <div class="row">

          <!-- Cliente -->
          <div class="col-12 col-md-4">
            <div class="row">
              <div class="col-10">
                <mat-form-field appearance="outline" class="custom-mat-input">
                  <mat-label>
                    Cliente
                    <span *ngIf="!(clientsTerm?.length || f['client']?.value)">(Escribe para buscar...)</span>
                  </mat-label>
                  <input type="text" matInput name="client" formControlName="client" [matAutocomplete]="autoClient"
                    [readonly]="readOnly" (optionSelected)="onClientSelectionChange()">
                  <mat-autocomplete #autoClient="matAutocomplete" [displayWith]="displayClientsFn" required>
                    <mat-option *ngFor="let client of $clients | async" [value]="client">
                      {{client.firstname}} {{client.lastname ? client.lastname : ''}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="f['client']?.errors?.['required']">
                    Cliente Obligatorio
                  </mat-error>
                  <mat-error *ngIf="f['client']?.errors?.['notFound']">
                    Cliente NO Encontrado (Agregar Nuevo?)
                  </mat-error>
                  <mat-error *ngIf="f['client']?.errors?.['notToBilling']">
                    Cliente NO cuenta con datos fiscales completos
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-2 pl-0">
                <button type="button" class="btn btn-manax m-0 p-2" (click)="openNewClientModal()">
                  <i class="material-icons">add</i>
                </button>
              </div>
            </div>
          </div>

          <!-- client -->
          <!--div class="col-md-4 field-container">
            <mat-form-field appearance="outline" >
              <mat-label style="font-weight: medium;">
                Cliente
                <span *ngIf="!(clientsTerm?.length || f.client?.value)">( Escribe para buscar... )</span>
              </mat-label>
              <input type="text" matInput name="client" formControlName="client" [matAutocomplete]="autoClient"
                [readonly]="readOnly || editting" (optionSelected)="onClientSelectionChange()">
              <mat-autocomplete #autoClient="matAutocomplete" [displayWith]="displayClientsFn" required>
                <mat-option *ngFor="let client of $clients | async" [value]="client">
                  {{client.firstname}} {{client.lastname ? client.lastname : ''}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="f.client?.errors?.required">
                Cliente Obligatorio
              </mat-error>
              <mat-error *ngIf="f.client?.errors?.notFound">
                Cliente NO Encontrado (Agregar Nuevo?)
              </mat-error>
              <mat-error *ngIf="f.client?.errors?.notToBilling">
                Cliente NO cuenta con datos fiscales completos
              </mat-error>
            </mat-form-field>
            <span class="field-actions">
              <button type="button" class="btn btn-link text-manax mx-0 p-1" (click)="openClientModal(f.client.value)"
                *ngIf="f.client.value?._id">
                <i class="material-icons">edit</i>
              </button>
              <button type="button" class="btn btn-link text-danger mx-0 p-1" (click)="clearClient()"
                *ngIf="f.client.value?._id && !editting">
                <i class="material-icons">clear</i>
              </button>
            </span>
          </div-->

          <!-- Serie -->
          <div class="col-md-2" *ngIf="!document._id">&nbsp;</div>
          <div class="col-md-2 col-12 ml-auto d-none d-md-block"
            *ngIf="!(!document._id || (document._id && document.status == invoiceStatuses.DRAFT))">&nbsp;</div>
          <div class="col-md-2 col-12 ml-auto field-container"
            *ngIf="((!document._id || (document._id && document.status == invoiceStatuses.DRAFT)) && !newSerie)">
            <div class="row">
              <div class="col-7 col-md-9">
                <mat-form-field appearance="outline">
                  <mat-label> Serie Factura </mat-label>
                  <mat-select name="serie" formControlName="serie">
                    <mat-option *ngFor="let serie of counters"
                      [value]="serie.reference_value?.serie">{{serie.reference_value?.serie}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f['serie']?.errors?.['required']">
                    Serie Obligatoria
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-5 col-md-3 pt-2 pl-0">
                <button type="button" class="btn btn-manax m-0 p-2" (click)="openNewCountersModal()">
                  <i class="material-icons">add</i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-2 col-12"
            *ngIf="(!document._id || (document._id && document.status == invoiceStatuses.DRAFT)) && newSerie">
            <mat-form-field appearance="outline">
              <input matInput name="serie" placeholder="Nueva Serie Factura" formControlName="serie" type="text">
            </mat-form-field>
          </div>

          <!-- Serie -->
          <!--div class="col-md-2" *ngIf="!document._id">&nbsp;</div>
          <div class="col-md-2 col-12 ml-auto d-none d-md-block"
            *ngIf="!(!document._id || (document._id && document.status == invoiceStatuses.DRAFT))">&nbsp;</div>
          <div class="col-md-2 col-12 ml-auto field-container"
            *ngIf="((!document._id || (document._id && document.status == invoiceStatuses.DRAFT)) && !newSerie)">
            <mat-form-field appearance="outline" >
              <mat-label>Serie Factura</mat-label>
              <mat-select name="serie" formControlName="serie">
                <mat-option *ngFor="let serie of counters"
                  [value]="serie.reference_value.serie">{{serie.reference_value.serie}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="f.serie?.errors?.required">
                Serie Obligatoria
              </mat-error>
            </mat-form-field>
            <span class="field-actions">
              <button type="button" class="btn btn-link text-manax mx-0 p-1" style="background-color: white;"
                (click)="openNewCountersModal()">
                <i class="material-icons">add</i> nueva
              </button>
            </span>
          </div>
          <div class="col-md-2 col-12"
            *ngIf="(!document._id || (document._id && document.status == invoiceStatuses.DRAFT)) && newSerie">
            <mat-form-field appearance="outline" >
              <input matInput name="serie" placeholder="Nueva Serie Factura" formControlName="serie" type="text">
            </mat-form-field>
          </div-->

          <!-- doc number -->
          <!--div class="col-md-1 col-6">
            <mat-form-field appearance="outline" >
              <mat-label style="font-weight: medium;">Nro. Factura</mat-label>
              <input matInput name="docNumber" placeholder="Número de factura" formControlName="docNumber" type="text"
                [readonly]="true" class="text-right">
            </mat-form-field>
          </div-->

          <!-- date -->
          <div class="col-md-2 col-12 order-4 order-md-3">
            <mat-form-field appearance="outline">
              <mat-label> Fecha de Emisión </mat-label>
              <input matInput name="date" formControlName="date" type="date" style="line-height: 11px;" class="d-flex"
                [readonly]="readOnly">
            </mat-form-field>
          </div>

          <!-- due date -->
          <div class="col-md-2 col-12 order-5 order-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Fecha de Vencimiento </mat-label>
              <input matInput name="dueDate" formControlName="dueDate" style="line-height: 11px;"
                (ngModelChange)="dueDateChange()" type="date" class="d-flex" [readonly]="readOnly">
            </mat-form-field>
          </div>

          <!-- status -->
          <div class="col-md-2 order-3 order-md-5" *ngIf="document._id">
            <div class="status" [ngStyle]="{'background-color': getInvoiceStatusColor(f['status'].value)}"
              [class.text-white]="f['status'].value === invoiceStatuses.CANCELLED">
              {{ getInvoiceStatusLabel(f['status'].value) }}
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-12">
            <hr>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h5 class="m-0 pb-1 title-section"> Conceptos </h5>
            <app-detail-list [items]="document.details || []" (listChange)="onListChange($event)"></app-detail-list>
            <button type="button" class="btn btn-outline-manax p-1" (click)="openTaskSearchModal()">
              <i class="material-icons">add</i> Añadir trabajo
            </button>
          </div>
        </div>

        <!--ng-container *ngFor="let item of f.details.controls; let i=index"-->
        <!--ng-container *ngFor="let item of [] let i=index">
          <div formArrayName="details">
            <div [formGroupName]="i">
              <div class="row mb-1">

                <div class="col-12 p-0">
                  <button type="button" class="btn btn-outline btn-accordion" (click)="toggleAccordion(i)">
                    <span class="accordion-left-content pull-left">
                      <span *ngIf="item.value.task">
                        Trabajo: {{ item.value.task.scheduledStart | date: 'dd/MM/yyyy' }} -
                      </span>
                      {{ item.value.detail }}
                    </span>
                    <span class="accordion-right-content pull-right">
                      <span class="d-none d-md-inline">
                        Subtotal: {{item.value.subtotal | money: { needSymbol:true } }}&nbsp;&nbsp;
                      </span>
                      <span class="d-none d-md-inline">
                        Impuestos: {{item.value.tax | money: { needSymbol:true } }} ({{item.value.taxPercentage}}%)
                        &nbsp;&nbsp;
                      </span>
                      <span>
                        Total: {{item.value.total | money: { needSymbol:true } }}
                      </span>
                      <i class="material-icons">
                        {{ accordionOpenIndexes.includes(i) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </i>
                    </span>
                  </button>
                </div>

                <div class="col-12 details-container" *ngIf="accordionOpenIndexes.includes(i)">
                  <div class="d-table details-container_table px-4 pt-2">

                    <div class="row" *ngIf="item.value.task">

                      <div class="col-12 col-md-11" style="font-size: 0.9em">
                        <app-task-modal-products [products]="item.value.task?.products" [readOnly]="readOnly"
                          [tax]="item.value.task?.tax" [taxPercentage]="item.value.task?.taxPercentage"
                          [status]="'mandale'" (totals)="taskProductsChange($event, item)">
                        </app-task-modal-products>
                      </div>

                      <div class="col-12 col-md-1">
                        <button type="button" class="btn btn-600 btn-outline m-0" (click)="removeItem(i)"
                          *ngIf="!readOnly">
                          <i class="material-icons">delete</i>
                        </button>
                      </div>
                    </div>


                    <div class="row" *ngIf="!item.value.task">

                      <div class="col-12 col-md-3">
                        <mat-form-field appearance="outline" >
                          <mat-label> Detalle </mat-label>
                          <input matInput type="text" [readonly]="readOnly || item.value.task" name="detail"
                            formControlName="detail" (ngModelChange)="updateItem(i)" />
                        </mat-form-field>
                      </div>

                      <div class="col-6 col-md-2" [readonly]="readOnly || item.value.task">
                        <app-input-decimal formControlName="subtotal" [decimals]="2" [initValue]="item.value.subtotal"
                          [readonly]="readOnly || item.value.task" [placeholder]="'Subtotal ' + curr"
                          (input)="updateItem(i)"></app-input-decimal>
                      </div>

                      <div class="col-6 col-md-2">
                        <app-input-decimal formControlName="taxPercentage" [decimals]="3"
                          [initValue]="item.value.taxPercentage" [readonly]="readOnly || item.value.task"
                          [placeholder]="'Impuestos (%)'" (input)="updateItem(i)"></app-input-decimal>
                      </div>

                      <div class="col-6 col-md-2">
                        <mat-form-field appearance="outline" >
                          <mat-label> Impuestos {{curr}} </mat-label>
                          <input matInput type="number" [readonly]="true" name="tax" formControlName="tax" />
                        </mat-form-field>
                      </div>

                      <div class="col-6 col-md-2">
                        <mat-form-field appearance="outline" >
                          <mat-label> Total {{curr}} </mat-label>
                          <input matInput type="number" [readonly]="true" name="total" formControlName="total" />
                        </mat-form-field>
                      </div>

                      <div class="col-12 col-md-1">
                        <button type="button" class="btn btn-600 btn-outline m-0" (click)="removeItem(i)"
                          *ngIf="!readOnly">
                          <i class="material-icons">delete</i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container-->

        <!-- new detail btn -->
        <!--div class="row pt-2">
          <div class="col-12">
            <button type="button" class="btn btn-600 btn-lilac-manax m-0 with" (click)="addItem()">
              <i class="material-icons">add</i> Añadir línea
            </button>
            <button type="button" class="btn btn-600 btn-outline-manax m-0 ml-2 with" (click)="openTaskSearchModal()">
              <i class="material-icons">add</i> Añadir trabajo
            </button>
          </div>
        </div-->

        <div class="row">
          <div class="col-12">
            <hr>
          </div>
        </div>

        <div class="row">

          <!-- totals -->
          <!--div
            class="col-md-6 mt-3 text-center d-flex flex-column align-items-center justify-content-center order-md-last">
            <div class="item-valor">
              <b>Subtotal: </b>
              <b>{{f.subtotal?.value | money: { needSymbol:true } }}</b>
            </div>
            <div class="item-valor">
              <b>Impuestos:</b>
              <b>{{f.tax?.value | money: { needSymbol:true } }}</b>
            </div>
            <div class="item-valor">
              <b>TOTAL:</b>
              <b>{{f.total?.value | money: { needSymbol:true } }}</b>
            </div>
          </div-->

          <!-- diseño grande
          <div class="col-md-6 mt-3 text-center d-flex flex-column align-items-center justify-content-center order-md-last">
            <div class="item-valor">
              <b>Subtotal: </b>
              <b>{{f.subtotal?.value | money: { needSymbol:true } }}</b>
            </div>
            <div class="item-valor">
              <b>Impuestos:</b>
              <b>{{f.tax?.value | money: { needSymbol:true } }}</b>
            </div>
            <div class="item-valor">
              <b>TOTAL:</b>
              <b>{{f.total?.value | money: { needSymbol:true } }}</b>
            </div>
          </div> -->

          <!-- notes -->
          <div class="col-md-12 mt-3 order-md-first box-area-grey d-flex flex-column">
            <label for="notes" class="label-area-grey">Observaciones:</label>
            <textarea matInput id="notes" name="notes" formControlName="notes" [readonly]="readOnly"
              class="tx-area-grey" [errorStateMatcher]="customErrorStateMatcher">
            </textarea>
          </div>
        </div>

        <div class="row pb-5">
          <div class="col-md-6 p-0">
            <div class="row">
              <div class="col-12">
                <mat-form-field class="px-3 mt-3" style="min-height: 65px;" appearance="outline">
                  <mat-label>Forma de pago</mat-label>
                  <mat-select name="paymentMethodType" formControlName="paymentMethodType"
                    (selectionChange)="onPaymentMethodTypeChange($event.value)">
                    <mat-option *ngFor="let key of paymentMethodTypesKeys" [value]="key">{{paymentMethodTypes[key]}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <!-- añadir cuando este definido lo de N° de cuenta
            <mat-form-field class="row" *ngIf="form.get('paymentMethod').value ==='Transferencia_bancaria'" >
              <mat-label>N° de cuenta</mat-label>
              <input matInput type="text" name="IBAN" [readonly]="readOnly" formControlName="iban" />
            </mat-form-field> 
            -->

            <div class="row">
              <div class="col-12">
                <div class="box-area-grey" style="width: 100% !important;">
                  <label for="paymentMethod" class="label-area-grey">Detalles forma de pago:</label>
                  <textarea id="paymentMethod" name="paymentMethod" formControlName="paymentMethod"
                    [readonly]="readOnly" class="tx-area-grey"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="pl-1 mt-3 d-flex align-items-center " style="min-height: 65px;">
              <div class="form-check m-0 mx-2">
                <label class="form-check-label" style="font-weight: bold; color: black;">
                  <input class="form-check-input input-sm" type="checkbox" [checked]="hasTermAndCond"
                    (change)="setTermAndCond()">
                  Añadir términos y condiciones
                  <span class="form-check-sign">
                    <span class="check"></span>
                  </span>
                </label>
              </div>
            </div>

            <div class="box-area-grey" *ngIf="hasTermAndCond">
              <label for="termsAndConditions" class="label-area-grey">Términos y condiciones:</label>
              <textarea matInput id="termsAndConditions" name="termsAndConditions" formControlName="termsAndConditions"
                [readonly]="readOnly" class="tx-area-grey" [errorStateMatcher]="customErrorStateMatcher"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row d-flex justify-content-end pull-right" *ngIf="!allDataToBilling">
          <button class="btn btn-600 text-danger" style="font-size: .8rem;"
            [ngClass]="{'btn-danger': cancelBtnHover, 'btn-outline-danger': !cancelBtnHover}"
            (click)="openCompanyModal(currentCompany)">Los datos fiscales de tu empresa están incompletos. Haz click
            aquí para completarlos.</button>
        </div>
      </div>


      <!-- actions -->
      <div class="col-12 task-footer pb-4">
        <div class="row">
          <div class="col-12 pt-2">
            <!--button mat-raised-button type="button" class="m-0 mt-2 mr-2 px-3 pull-left btn btn-600 btn-outline"
              (click)="dialog.close()" *ngIf="readOnly">
              Cerrar
            </button-->

            <!-- edit -->
            <button mat-raised-button type="button" class="m-0 mt-2 mr-2 px-3 pull-left btn btn-600 btn-outline"
              (click)="cancelSubmit()" *ngIf="!readOnly">
              Cancelar Cambios
            </button>

            <button mat-raised-button [disabled]="saving" type="button" (click)="onSubmit()"
              class="m-0 mt-2 ml-2 px-3 pull-right btn btn-600 btn-manax"
              *ngIf="!readOnly && (document._id && document.status != invoiceStatuses.DRAFT)">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar Cambios
            </button>

            <button mat-raised-button [disabled]="saving" type="button" (click)="issueInvoice()"
              class="m-0 mt-2 ml-2 px-3 pull-right btn btn-600 btn-manax"
              *ngIf="!readOnly && (!document._id || document.status == invoiceStatuses.DRAFT)">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Emitir Factura
            </button>

            <button mat-raised-button [disabled]="saving" type="button" (click)="issueInvoice()"
              class="m-0 mt-2 ml-2 px-3 pull-right btn btn-600 btn-manax"
              *ngIf="readOnly && document.status == invoiceStatuses.DRAFT">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Emitir Factura
            </button>

            <button mat-raised-button [disabled]="saving" type="button" (click)="saveAsDraft()"
              class="m-0 mt-2 ml-2 px-3 pull-right btn btn-600 btn-outline-manax"
              *ngIf="!readOnly && (!document._id || document.status == invoiceStatuses.DRAFT)">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar como Borrador
            </button>

            <button mat-raised-button type="button" (click)="setPaidInvoice()"
              class="m-0 mt-2 ml-2 px-3 pull-right btn btn-600 btn-manax"
              *ngIf="readOnly && (document.status == invoiceStatuses.ISSUED)">
              Registrar Pago
            </button>

            <button mat-raised-button type="button" (click)="removePaymentsInvoice()"
              class="m-0 mt-2 ml-2 px-3 pull-right btn btn-600 btn-manax"
              *ngIf="readOnly && (document.status == invoiceStatuses.PAID)">
              Eliminar Pago
            </button>

            <!-- read -->
            <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
              *ngIf="readOnly" (click)="openDocument()">
              Ver PDF
            </button>

            <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
              *ngIf="readOnly && ((document.status == invoiceStatuses.PAID) || (document.status == invoiceStatuses.ISSUED))"
              (click)="sendEmail()">
              Enviar Factura por email
            </button>

            <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
              *ngIf="readOnly && ((document.status == invoiceStatuses.PAID) || (document.status == invoiceStatuses.ISSUED) || (document.status == invoiceStatuses.DRAFT))"
              (click)="download()">
              Descargar Factura
            </button>

            <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
              *ngIf="readOnly && (document.status == invoiceStatuses.PAID)" (click)="openUnderConstructionDialog()">
              Enviar Recibo por email
            </button>

            <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 pull-right btn btn-outline-manax"
              *ngIf="readOnly && (document.status == invoiceStatuses.PAID)" (click)="downloadReceipt()">
              Descargar Recibo
            </button>

            <!-- <button mat-raised-button type="button" (click)="cancelDocument()"
              class="m-0 mt-2 ml-2 px-3 pull-left btn btn-600"
              *ngIf="readOnly && (document.status != invoiceStatuses.CANCELLED)"
              (mouseenter)="toggleCancelBtnHover(true)" (mouseleave)="toggleCancelBtnHover(false)">
              Cancelar Factura
            </button> -->

          </div>
        </div>
      </div>
    </div>
  </form>
</div>